import React from 'react'
import {Row, H3} from '../UI/index.js'
import AnalyticsInsightCard from './AnalyticsInsightCard.js'
import {AnalyticsViewType} from '../../views/planner/Analytics.js'

interface analyticsCardData {
    title: string
    icon: string
    key: AnalyticsViewType['key']
    text: string
}

interface InsightsBarProps {
    cards: analyticsCardData[]
    selectedAnalytics: analyticsCardData['key']
    setSelectedAnalytics: (key: analyticsCardData['key']) => void
    branding: any
}
/**
 * @param {InsightsBarProps} props
 * @returns {React.ReactElement} The rendered InsightsBar component
 */
function InsightsBar({cards, selectedAnalytics, setSelectedAnalytics, branding}: InsightsBarProps): React.ReactElement {
    return (
        <Row style={{gap: 12}}>
            {cards.map((card) => (
                <AnalyticsInsightCard
                    key={card.key}
                    title={card.title}
                    icon={card.icon}
                    selected={selectedAnalytics === card.key}
                    onClick={() => setSelectedAnalytics(card.key)}
                    branding={branding}
                >
                    <H3 style={{margin: 0, fontSize: 32, fontWeight: 400}}>{card.text}</H3>
                </AnalyticsInsightCard>
            ))}
        </Row>
    )
}

export default InsightsBar
